export default {
  store_namespace: 'imputation',
  auth_feature: 'imputation',
  new_route_name: "AdminImputationNew",
  edit_route_name: "AdminImputationEdit",
  detail_route_name: "AdminImputationDetail",
  csv_export_filename_prefix: 'imputation',
  hide_action_new_button: true,
  hide_action_pdf_button: false,
  hide_action_edit_button: false,
  hide_action_delete_button: true,
  export_csv: true,
  export_pdf: true,
  duplications: true,
  title_field: 'code',
  sort_by: 'code',
  sort_desc: false,
  fields: [
    {
      name: 'code',
      label: "Code",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      sortable: true,
    },
    {
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
      inDetail: true,
      sortable: true,
      inCsvExport: true,
      inPdfExport: true,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/Imputation/config.js